<template>
  <span v-if="workingReward">
    <v-row class="mt-8">
      <v-col cols="12">
        <v-text-field
          label="Reduction Amount"
          v-model="workingReward.ibLoginFeeReductionAmount"
          type="number"
          hint="Ex. 5.00"
          prefix="$"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="ibLoginFeeReductionAmount"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { IbLoginFeeReductionReward } from '@/api/product/levelrewards/rewards';
import { ValidationTool } from '@/util';

@Component
export default class IbLoginFeeReductionRewardEditor extends Vue {
  @Prop()
  value!:IbLoginFeeReductionReward;

  workingReward:IbLoginFeeReductionReward | null = null;

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingReward = this.value.clone() as IbLoginFeeReductionReward;
  }

  onChange() {
    this.$emit('input', this.workingReward);
  }
}
</script>

<style lang="scss" scoped>
</style>
